<template>
  <div>
    <nav v-if="breadcrumb" class="border-b border-gray-300 py-2 px-2 mb-4 md:px-0">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'customers'}">Bandwidth policies</router-link>
          </div>
          <div class="text-xl text-primary">
            Bandwidth policies
          </div>
        </div>
        <div class="">
          <div class="inline-block relative float-right">
            <router-link :to="{name:'new_bandwidth_policy'}"
                         style="color: white !important;" v-if="$store.getters.can('create_bandwidth_policy')"
                         class="bg-teal-500 text-white hover:bg-teal-700 py-2 px-4 rounded-sm inline-flex items-center">
              New Policy
            </router-link>
          </div>
        </div>
      </div>
    </nav>
    <div class="pb-4">
      <div class="bg-white pt-3 border rounded shadow-sm">
        <div class="font-semibold mx-2 text-gray-600">{{ title }}</div>
        <div class="flex justify-between pt-2 px-3">
          <div>
            <label class="block tracking-wide text-gray-700">Records</label>
            <select v-model="recordsPerPage" @change="loadStats(currentPage)"
                    class="block appearance-none w-full bg-white border border-gray-300  px-4 py-2  rounded leading-tight focus:outline-none focus:border-gray-500">
              <option>5</option>
              <option>10</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
              <option>250</option>
            </select>
          </div>
          <div>
            <label class="block tracking-wide text-gray-700">Search</label>
            <input v-model="searchString" @change="loadStats(currentPage)"
                   class="appearance-none block w-full text-gray-700 border border-gray-300 rounded py-2 px-4 leading-tight focus:outline-none focus:border-gray-500"
                   type="text" placeholder="Search">
          </div>
        </div>
        <div class=" overflow-auto ">
          <table v-if="!loading" class="table-auto w-full">
            <thead>
            <tr class="border-b font-bold">
              <td class="px-4 py-2"></td>
              <td class="px-4 py-2">Policy Name</td>
              <td class="px-4 py-2">Max Upload</td>
              <td class="px-4 py-2">Max Download</td>
              <td class="px-4 py-2">Description</td>
            </tr>
            </thead>
            <tbody>
            <tr class="border-b" v-for="(policy,index) in bandwidthPolicies" :key="policy.id">
              <td class="px-4 py-2">{{ index + 1 }}</td>
              <td class="px-4 py-2">
                <router-link :to="{name:'bandwidth_policy', params:{policyId: policy.id}}">
                  {{ policy.name }}
                </router-link>
              </td>
              <td class="px-4 py-2">{{ policy.max_upload +" "+ policy.max_upload_unit }}</td>
              <td class="px-4 py-2">{{ policy.max_download +" "+ policy.max_download_unit }}</td>
              <td class="px-4 py-2">{{ policy.description }}</td>
            </tr>
            </tbody>
          </table>

          <div v-else class="py-6 text-center w-full">
            <feather animation="spin" type="loader" size="32" class="mr-4"></feather>
            <p>Loading...</p>
          </div>
          <Pagination class="py-2 px-3" :total-count="bandwidthPoliciesCount" :current-page="currentPage"
                      :tag="'connections'" :offset="offset"
                      :records-count="bandwidthPolicies.length || 0 "
                      :click-handler="loadStats" :records-per-page="parseInt(recordsPerPage)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import GraphQl from "@/services/graphql.service";

export default {
  name: "BandwidthPolicies",
  components: {Pagination},
  data() {
    return {
      searchString: '',
      recordsPerPage: this.rowsPerPage,
      bandwidthPolicies: [],
      bandwidthPoliciesCount: 0,
      currentPage: 1,
      loading: true
    }
  },
  props: {
    title: {type: String, default: 'Bandwidth policies'},
    configs: Object,
    rowsPerPage: {type: Number, default: 10},
    breadcrumb: {default: true, type: Boolean}
  },
  mounted() {
    this.loadStats();
  },

  computed: {
    offset: function () {
      return (this.currentPage - 1) * this.recordsPerPage;
    }
  },
  watch: {
    searchString: function () {
      this.currentPage = 1;
    }
  },
  methods: {
    loadStats(newPage) {
      this.currentPage = newPage || 1;
      this.loading = true
      let params = 'limit: ' + this.recordsPerPage + ', ' +
          'offset: ' + this.offset + ', ' +
          'order: "created_at desc", ' +
          'search: "' + this.searchString + '"';
      GraphQl.sendRequest('{bandwidthPoliciesCount(' + params + ') bandwidthPolicies(' + params + '){id name max_download max_download_unit max_upload max_upload_unit description}}')
          .then(response => {
            this.bandwidthPolicies = response.bandwidthPolicies;
            this.bandwidthPoliciesCount = response.bandwidthPoliciesCount;
          })
          .finally(() => {
            this.loading = false;
          })
    }
  }
}
</script>

<style scoped>

</style>